import React, { useEffect, useState } from 'react';

function getFloat(value = 0) {
    return parseFloat(parseFloat(value).toFixed(2));
}
function ResourceEdit({ fieldKey = null, isFocused = false,
    resource, updateResource, max,
    field, prefix = "$", editable = false,
    value = false, refresh = () => { } }) {

    const [fieldData, fieldDataSet] = useState(getFloat(resource[field]));
    useEffect(() => {
        if (value !== false) {
            const temp = Math.ceil(parseInt(fieldData))
            const tempNew = Math.ceil(parseInt(value))
            if (temp !== tempNew) {
                fieldDataSet(getFloat(value));
            }
        }
    }, [value]);
    const updateField = (input = '') => {
        let val = input;
        if (val.startsWith('$')) {
            val = val.substring(1, val.length);
            input = val;
        }
        let temp = NaN;
        try {
            temp = parseFloat(val);
        } catch {
            temp = NaN;
        }

        if (temp && temp >= 100000) {
            return;
        }
        if (isNaN(temp)) {
            temp = 0;
        }

        if (temp < 0) {
            temp = 0;
        }
        if (temp > max) {
            return;
            // val = max;
            // fieldDataSet(max);
        } else {
            if (input.length === 0) {
                fieldDataSet('0');
            } else if (input.length === 1) {
                fieldDataSet(input);
            } else {
                fieldDataSet(input.replace(/^0/, ''));
            }
        }

        let fieldToUpdate = field;
        let fieldToUpdateValue = temp; // this is used when user edits cost
        if (resource.cost && field === 'cost' && resource.type === 'Vendor') {
            const newHour = temp / parseFloat(resource.cost);
            fieldToUpdate = 'hours';
            fieldToUpdateValue = parseFloat(newHour);
        }
        const updatedData = { ...resource, }
        updatedData[fieldToUpdate] = fieldToUpdateValue;
        updateResource(updatedData, resource, fieldKey);
        setTimeout(refresh, 100);

    }
    const calculatedFieldData = () => {
        if (editable === false) {
            return value;
        }
        if (field === 'amount' && resource.amountType === 'percentage') {
            const temp = resource.cost * ((resource.amount / 100) + 1);
            return temp.toFixed(2).replace('.00', '.');
        }
        return fieldData;
    }
    const isDigit = (inp = '') => {
        const valid = ['$', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];
        for (let i = 0; i < inp.length; i++) {
            if (valid.includes(inp[i]) === false) {
                ;
                return false;
            }
        }
        return true;
    }
    return <input
        value={prefix + calculatedFieldData()}
        // onKeyPress={(e) = > {}}
        autoFocus={isFocused}
        onChange={(e) => {
            if (isDigit(e.target.value) === false) {
                return false;
            }
            if (editable) {
                const val = e.target.value;
                updateField(val);
            }
        }}
        readOnly={editable === false}
        style={{
            marginLeft: 100,
            //marginRight: 30,
            textAlign: 'right', right: '0',
            top: '9px', paddingLeft: '0px', color: 'rgba(0,0,0,0.5)',
            fontWeight: '600', position: 'relative',
            width: 54, border: 'none', fontSize: '14px'

        }}
    />
}
export default ResourceEdit;